module.exports = __webpack_public_path__ + "static/media/Slider 1 1.ec405adb.jpg";